export default {
    title: "Catalogare",
    noAvailableItems: "Nessun prodotto disponibile su ordinazione."
}